import { FunctionComponent } from 'react';
import { MediaGalleryCarousel } from './MediaGalleryCarousel';
import { usePropertyPageQuery } from '../../../../graphql/usePropertyPageQuery';
import { getInitialSlideIndex } from '../../../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { IMediaGalleryModal } from '../../../../contexts/MediaGalleryModalContext/MediaGalleryModalContext';
import { MediaItemV2 } from '../../../../../app-kit/components/Image/types';
import { mapApiWebLinkToWebLinkProps } from '../../../../../app-kit/components/WebLink/helpers/mapApiWebLinkToWebLinkProps';

interface MediaGalleryCarouselProps {
  opened: boolean;
  onClose: () => void;
  initialImageIndex?: number;
  galleryItemKey?: string;
  openAction: IMediaGalleryModal['openAction'];
}

export const MediaGalleryCarouselWithData: FunctionComponent<MediaGalleryCarouselProps> = ({
  opened,
  onClose,
  initialImageIndex,
  galleryItemKey,
  openAction,
}) => {
  const propertyPageBySlugData = usePropertyPageQuery()?.data?.propertyPageBySlugV3;
  const gallery = propertyPageBySlugData?.mediaGalleryV2;

  if (!gallery) return null;

  const initialSlideIndex = getInitialSlideIndex({ gallery, galleryItemKey, initialImageIndex });

  const itemsWithWebLinkProps: MediaItemV2[] = gallery.items.map((item) => ({
    ...item,
    searchByImageButton: item.searchByImageButton
      ? mapApiWebLinkToWebLinkProps(item.searchByImageButton)
      : null,
  }));

  return (
    <MediaGalleryCarousel
      opened={opened}
      onClose={onClose}
      galleryItems={itemsWithWebLinkProps}
      mediaButtonCounts={gallery.mediaCounts}
      timeline={gallery.timeline}
      initialSlideIndex={initialSlideIndex}
      openAction={openAction}
    />
  );
};
